import { Authentication } from '@leedpulse-monorepo/classes';
import { IUser } from '@leedpulse-monorepo/interfaces';
import HttpClient from '../../../core/HttpClient';

export interface SearchCompanyUsersResult {
  hits: (IUser & { avatar?: string })[];
  nbHits: number;
}

async function searchCompanyUsers(
  { companyId, q = '', page = 0, hitsPerPage = 20 }: { companyId: string; q?: string; page?: number; hitsPerPage?: number },
  authentication: Authentication | null,
): Promise<SearchCompanyUsersResult> {
  if (!authentication) {
    throw new Error('Authentication is required');
  }

  const params = new URLSearchParams({
    q,
    page: String(page),
    hitsPerPage: String(hitsPerPage),
    companyId,
  });

  const json = await HttpClient.get(
    `/algolia/search/frontendleedflow/users?${params.toString()}`,
    authentication.token,
  );

  return { hits: json?.hits ?? [], nbHits: json?.nbHits ?? 0 };
}

export default searchCompanyUsers;
